/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerProducts200Response
 */
export interface GetCustomerProducts200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerProducts200Response
     */
    items: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerProducts200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerProducts200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerProducts200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetCustomerProducts200Response interface.
 */
export function instanceOfGetCustomerProducts200Response(value: object): value is GetCustomerProducts200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetCustomerProducts200ResponseFromJSON(json: any): GetCustomerProducts200Response {
    return GetCustomerProducts200ResponseFromJSONTyped(json, false);
}

export function GetCustomerProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerProducts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'],
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetCustomerProducts200ResponseToJSON(json: any): GetCustomerProducts200Response {
    return GetCustomerProducts200ResponseToJSONTyped(json, false);
}

export function GetCustomerProducts200ResponseToJSONTyped(value?: GetCustomerProducts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'],
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

